import { fetchUserDrafts } from '@/utils/http/fetchUserDrafts';
import { fetchProductTypeAction } from '@/redux/productTypes/actions/fetchProductTypeAction';
import { selectProductTypes } from '@/redux/productTypes/getters/selectProductTypes';
import { Thunk } from '@/redux/types';
import { SetDraftsAction, UserDraftsActionTypes } from '@/redux/userDrafts/types';

export const getUserDraftsAction =
  (userId: string): Thunk<Promise<void>, SetDraftsAction> =>
  (dispatch, getState) =>
    fetchUserDrafts(userId).then(
      (drafts) => {
        const productTypes = selectProductTypes(getState());
        drafts.forEach(({ productTypeId }) => {
          if (!productTypes[productTypeId]) {
            dispatch(fetchProductTypeAction(productTypeId)).catch(() => {
              /* ignore if the product type is not available anymore */
            });
          }
        });

        dispatch({
          type: UserDraftsActionTypes.SET_DRAFTS,
          drafts: drafts.map((userDraft) => ({ userDraft })),
        });
      },
      () => {
        /* ignore failed fetchUserDrafts */
      }
    );
